<template>
  <div class="register-outer-wrapper">
    <my_title_index :title="infor.title"></my_title_index>
    <div :class="`basic-member-register basic-member-register-${pc_widgets_infor.moduleStyle}`">
      <div class="tooptipPart module_edit_btn">
        <my_hover_btn :tips="$t('widgets_basic_article_classification_index_336')" btnIcon="el-icon-edit" @changeStyle="changeStyle('style')"></my_hover_btn>
        <my_close_btn v-if="false" :module="module" :column="column" :moduleIndex="module_index"></my_close_btn>
      </div>
      <div class="main-wrapper">
        <div class="main-content">
          <h2 class="register-title">
            <span class="label-placeholder" :style="labelStyle"></span>
            <span>{{ listArr.title }}</span>
          </h2>
          <p class="register-tip">
            <span class="label-placeholder" :style="labelStyle"></span>
            <span>{{$t('widgets_basic_member_register_index_2631')}}</span>
          </p>
          <form class="form-register">
            <template v-for="item in formList">
              <template v-if="item.key==='password'">
                <div :class="{'form-item':true,'form-item-required':item.is_require}">
                  <label class="my-label" for="" :style="labelStyle">{{ item.name }}</label>
                  <input type="password"
                         class="member-input"
                         ::aria-placeholder="$t('widgets_basic_member_center_components_tab_profile_2614', [item.name])"
                         ::placeholder="$t('widgets_basic_member_center_components_tab_profile_2614', [item.name])"
                         :style="contentStyle"
                         disabled>
                </div>
                <div :class="{'form-item':true,'form-item-required':item.is_require}">
                  <label class="my-label" for="" :style="labelStyle">{{$t('widgets_basic_member_center_components_tab_password_2603')}}</label>
                  <input type="password"
                         class="member-input"
                         ::aria-placeholder="$t('widgets_basic_member_center_components_tab_profile_2614', [item.name])"
                         ::placeholder="$t('widgets_basic_member_center_components_tab_profile_2614', [item.name])"
                         :style="contentStyle"
                         disabled>
                </div>
              </template>
              <template v-else-if="item.key==='auth_code'">
                <div class="form-item form-item-verify">
                  <span class="label-placeholder" :style="labelStyle"></span>
                  <input class="member-input member-input-verify"
                         type="text"
                         :aria-placeholder="getLang($t('view_login_index_47'))"
                         :placeholder="getLang($t('view_login_index_47'))"
                         :style="contentStyle"
                         disabled>
                  <button class="btn-verify" type="button" :style="buttonStyle" @click="onClickVerifyBtn">{{$t('components_verificationbutton_index_2494')}}</button>
                </div>
              </template>
              <div v-else :class="{'form-item':true,'form-item-required':item.is_require}">
                <label class="my-label" for="" :style="labelStyle">{{ item.name }}</label>
                <input type="text"
                       class="member-input"
                       ::aria-placeholder="$t('widgets_basic_member_center_components_tab_profile_2614', [item.name])"
                       ::placeholder="$t('widgets_basic_member_center_components_tab_profile_2614', [item.name])"
                       :style="contentStyle"
                       disabled>
              </div>
            </template>
            <div class="form-item form-item-slide">
              <span class="label-placeholder" :style="labelStyle"></span>
              <div class="member-input input-slide">
                <div id="nc" class="sm-pop-inner nc-container">
                  <div class="nc_1_nocaptcha" id="nc_1_nocaptcha">
                    <div id="nc_1_wrapper" class="nc_wrapper">
                      <div id="nc_1_n1t" class="nc_scale">
                        <div id="nc_1__bg" class="nc_bg" style="width: 0px;"></div>
                        <span id="nc_1_n1z" class="nc_iconfont btn_slide" style="left: 0px;"></span>
                        <div id="nc_1__scale_text" class="scale_text slidetounlock"><span class="nc-lang-cnt"
                                                                                          data-nc-lang="SLIDE">{{$t('widgets_basic_member_register_index_2632')}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-item form-item-terms">
              <span class="label-placeholder" :style="labelStyle"></span>
              <div class="form-item-terms-content">
                <div>
                  <label class="checkbox-read-wrapper" v-if="regData.agreement">
                <span class="checkbox-wrapper">
                    <input class="my-checkbox" type="checkbox">
                    <span class="mock-checkbox"></span>
                </span>
                    <span>{{$t('widgets_basic_member_register_index_2633')}}<span class="text-highlight" @click.stop.prevent="onClickTerms">{{$t('widgets_basic_member_register_index_2634')}}</span></span>
                  </label>
                </div>
                <div>{{$t('widgets_basic_member_register_index_2635')}}<span class="text-highlight btn-login" @click="onClickLoginBtn">{{$t('widgets_basic_member_register_index_2636')}}</span>
                </div>
              </div>
            </div>
            <div class="form-item">
              <span class="label-placeholder" :style="labelStyle"></span>
              <button class="btn-register" type="button" :style="buttonStyle" @click="onClickRegisterBtn">{{$t('router_default_91')}}</button>
            </div>
          </form>
        </div>
      </div>
      <div class="img-wrapper" v-if="pc_widgets_infor.moduleStyle!==1 || isMobile">
        <img :src="infor.img" :alt="$t('router_default_91')">
        <div
          class="tooptipPart"
          style="top: initial; bottom: 0;"
        >
          <my_hover_btn :tips="$t('widgets_basic_banner_index_439')" btnIcon="el-icon-edit" @changeStyle="onClickEditImgBtn"></my_hover_btn>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import dialog from "./compoments/dialog";
import {
  getUserRegConfig
} from "@/api/app.js";
import Vue from "vue";

export default {
  name: "basic_member_register_index.vue",
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      regData: {},
      formList: [],
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.app.view_pattern === 'mb'
    },
    infor() {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor
    },
    mb_widgets_infor() {
      return this.module.data.mb_widgets_infor
    },
    listArr() {
      return this.module.data.listArr
    },
    labelStyle() {
      return this.$utils.getFontStyle(this.pc_widgets_infor.labelFont)
    },
    contentStyle() {
      return {
        ...this.$utils.getFontStyle(this.pc_widgets_infor.contentFont),
        ...this.$utils.getBackground(this.pc_widgets_infor.background),
      }
    },
    buttonStyle() {
      return {
        ...this.$utils.getBackground(this.pc_widgets_infor.buttonBackground),
        ...this.$utils.getFontStyle(this.pc_widgets_infor.buttonFont),
        ...this.$utils.getBorderRadiusStyle(this.pc_widgets_infor.buttonBorderRadius),
      }
    },
  },
  watch: {
    'pc_widgets_infor.moduleStyle': function (moduleStyle) {
      if (moduleStyle === 1) {
        return
      }
      let defaultImg = {
        2: 'https://staticjs.71360.com/static/txys-001/image/illustration/member_register_right.png',
        3: 'https://staticjs.71360.com/static/txys-001/image/illustration/member_register_left.png',
      }
      if (this.isDefaultImg()) {
        this.pc_widgets_infor.img = defaultImg[moduleStyle]
      }
    }
  },
  methods: {
    changeStyle(tabName) {
      this.templet.changeStyle(this.module, tabName)
    },
    onClickEditImgBtn() {
      this.$store.commit('image_upload/set_fileType', 1)
      this.$store.commit('image_upload/set_fileLimit', 1)
      this.$store.commit("image_upload/set_showTag", true)
      this.$store.state.image_upload.imgFile = (e) => {
        this.infor.img = e[0].filePath
      }
    },
    onClickVerifyBtn() {
      this.$message.info(i18n.t('widgets_basic_member_register_index_2637'))
    },
    onClickTerms() {
      this.showTermsDialog()
    },
    showTermsDialog() {
      if (this.dialogInstance) {
        this.dialogInstance.visible = true
      } else {
        let Dialog = Vue.extend(dialog)
        let dialogInstance = new Dialog({
          propsData: {
            title: this.regData.title,
            content: this.regData.content
          }
        })
        dialogInstance.$mount()
        document.querySelector('#app_child_frame').appendChild(dialogInstance.$el)
        this.dialogInstance = dialogInstance
      }
    },
    onClickRegisterBtn() {
      this.$message.info(i18n.t('components_set_link_components_submit_form_index_2470'))
    },
    onClickLoginBtn() {
      this.templet.is_jump(() => {
        this.$router.push('/user_login')
      })
    },
    getRegConfig() {
      getUserRegConfig().then(data => {
        console.log('注册表单：', data)
        data = data.data || {}
        this.regData = data
        this.formList = data.reg_select || []
      })
    },
    isDefaultImg() {
      return this.pc_widgets_infor.img.indexOf('/illustration/member_register_') > 0
    },
  },
  created() {
    this.dialogInstance = null
    this.getRegConfig()
    // this.onClickTerms()   // 开发调试用
  }
}
</script>

<style lang="scss" scoped>
@import "./src/css/components/slide_verify";

.basic-member-register {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding-bottom: 30px;
}

.register-title {
  color: var(--theme_color);
  font-size: 24px;
  margin-top: 20px;
  white-space: nowrap;
}

.register-tip {
  font-size: 18px;
  margin-top: 10px;
  white-space: nowrap;
}

.form-item {
  display: flex;
  align-items: center;
  margin-top: 20px;

  .my-label {
    width: 5em;
    text-align: right;
  }

  &.form-item-required {
    .my-label:before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }
}

.label-placeholder {
  width: 5em;
  display: inline-flex;
  font-size: 12px;
}

.member-input {
  display: inline-block;
  //width: 400px;
  flex: 1;
  height: 45px;
  line-height: 45px;
  background: #F7F8FB;
  border-radius: 3px;
  padding-left: 10px;
  border: 1px solid transparent;
  outline: none;
  margin-left: 20px;
}

.member-input-verify {
  width: 5em;
}


.form-item-terms-content {
  display: flex;
  justify-content: space-between;
  flex: 1;
  //width: 400px;
  padding-left: 20px;
}

.text-highlight {
  color: var(--theme_color);
}

.btn-login {
  cursor: pointer;
}

.checkbox-read-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;

  .checkbox-wrapper {
    width: 16px;
    height: 16px;
    position: relative;
    margin-right: 5px;
  }

  .my-checkbox {
    opacity: 0;
  }

  .mock-checkbox {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid #EEEEEF;
    border-radius: 2px;
    background: #F3F6F9;

    &:after {
      box-sizing: content-box;
      content: "";
      border: 1px solid #fff;
      border-left: 0;
      border-top: 0;
      height: 8px;
      left: 5px;
      position: absolute;
      top: 1px;
      transform: rotate(45deg) scaleY(0);
      width: 4px;
      transition: transform .15s ease-in .05s;
      transform-origin: center;
    }
  }

  .my-checkbox:checked + .mock-checkbox {
    background: var(--theme_color);
  }

  .my-checkbox:checked + .mock-checkbox:after {
    opacity: 1;
    transform: rotate(45deg) scaleY(1);
  }
}

.btn-register, .btn-verify {
  //width: 400px;
  flex: 1;
  height: 45px;
  line-height: 45px;
  background: var(--theme_color);
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  margin-left: 20px;
}

.btn-verify {
  flex-grow: 0;
  flex-basis: 120px;
}

.basic-member-register-1 {
  align-items: center;
}

.pc_pattern .basic-member-register-1 {
  .register-title, .register-tip {
    text-align: center;
  }

  .main-wrapper {
    width: 100%;
    max-width: 500px;
  }

  .member-input {
    border: 1px solid transparent;

    &:hover {
      border-color: var(--theme_color);
    }

    &:focus {
      border-color: var(--theme_color);
    }
  }
}

.basic-member-register-2, .basic-member-register-3, .mb_pattern .basic-member-register {
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-left: 0;
  margin-right: 0;

  .main-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .form-register {
    max-width: 500px;
  }

  .img-wrapper {
    align-self: stretch;
    flex: 1;
    position: relative;

    &:hover {
      .tooptipPart {
        display: block;
      }
    }

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
}

.basic-member-register-2 {
  .main-wrapper {
    padding-left: 10%;
  }
}

.basic-member-register-2, .mb_pattern .basic-member-register {
  .main-wrapper {
    width: 53%;
    display: flex;
    justify-content: flex-end;
    padding-right: 5%;
    padding-left: 10%;
  }

  .img-wrapper {
    width: 47%;
  }

  .form-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .form-item-required .my-label:before {
    position: absolute;
    left: -10px;
  }

  .form-item-verify {
    display: flex;
    flex-direction: revert;
  }

  .member-input {
    width: 100%;
    margin-left: 0;
    padding-left: 0;
  }

  .label-placeholder {
    display: none;
  }

  .my-label {
    width: auto;
  }

  .member-input {
    background: transparent;
    border-bottom: 1px solid #b0b0b0;

    &:hover {
      border-bottom: 1px solid var(--theme_color);
    }

    &:focus {
      border-bottom: 1px solid var(--theme_color);
    }
  }

  .form-item-terms-content {
    width: 100%;
    padding-left: 0;
  }

  .btn-register {
    width: 100%;
    margin-left: 0;
  }


}

.pc_pattern .basic-member-register-3 {
  .main-wrapper {
    order: 2;
    width: 53%;
  }

  .register-title {
    padding-left: 20px;
  }

  .register-tip {
    padding-left: 20px;
  }

  .main-content {
    padding-left: 7%;
    padding-right: 7%;
  }

  .img-wrapper {
    order: 0;
    width: 47%;
  }
}

input::-webkit-input-placeholder {
  font-style: inherit;
  text-decoration: inherit;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  text-align: inherit;
  background-image: inherit;
  -webkit-background-clip: text;
}

input:-moz-placeholder {
  font-style: inherit;
  text-decoration: inherit;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  text-align: inherit;
  background-image: inherit;
  -webkit-background-clip: text;
}

input::-moz-placeholder {
  font-style: inherit;
  text-decoration: inherit;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  text-align: inherit;
  background-image: inherit;
  -webkit-background-clip: text;
}

input:-ms-input-placeholder {
  font-style: inherit;
  text-decoration: inherit;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  text-align: inherit;
  background-image: inherit;
  -webkit-background-clip: text;
}

.mb_pattern .basic-member-register {
  flex-direction: column;

  .main-wrapper {
    width: 100%;
    order: 2;
    padding-left: 5%;
    padding-right: 5%;
  }

  .main-content {
    padding-left: 0;
  }

  .img-wrapper {
    width: 100%;
    order: 1;
  }
}

// 滑动验证
.basic-member-register {
  .form-item-slide.form-item {
    height: 40px;

    .member-input {
      border: none;

      &:hover {
        border: none;
      }
    }
  }

  .input-slide {
    position: relative;
    height: 40px;
    background: transparent;
    padding-left: 0;

    .nc-container #nc_1_wrapper {
      width: 100%;
    }

    #nc_1_n1z, .btn_slide {
      height: 34px;
    }

    .nc-lang-cnt {
      font-size: 12px;
    }

    .nc-lang-cnt {
      vertical-align: top;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_member_register/index.vue